export default __webpack_public_path__ + "static/media/RD-4.94896187.JPG";